import { Button, Menu } from '@mantine/core';
import { IconBulb } from '@tabler/icons-react';
import { type FC } from 'react';
import { Link } from 'react-router';
import { useCustomerIntelligenceEnabled } from '../../features/intelligence/hooks/useIntelligence';
import MantineIcon from '../common/MantineIcon';
import { INTELLIGENCE_PAGES } from './intelligencePages';

export const IntelligenceNavButton: FC<{ projectUuid: string }> = ({
    projectUuid,
}) =>
    useCustomerIntelligenceEnabled() ? (
        <Menu withArrow shadow="lg" position="bottom-start" offset={-2}>
            <Menu.Target>
                <Button
                    variant="default"
                    size="xs"
                    fz="sm"
                    leftSection={
                        <MantineIcon color="ldGray.6" icon={IconBulb} />
                    }
                >
                    Intelligence
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                {INTELLIGENCE_PAGES.map(([label, path]) => (
                    <Menu.Item
                        key={path}
                        component={Link}
                        to={`/projects/${projectUuid}/intelligence/${path}`}
                    >
                        {label}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    ) : null;
